// Bookkeeping columns the integration crawler attaches to every integration listing
// config (see bronco/src/bronco/integration/lib/integration/integration.go). `row_key`
// holds the provider's record ID, `row_hash` a change-detection hash — neither is ever
// shown to a user.
//
// They must be excluded from any "first column" heuristic. Configs created before
// DEV-11580 (Apr 2026) persisted them with order 0, ahead of the real data columns, so
// picking the lowest-order column landed on a SHA hash and the listing table came back
// in apparent random order. See DEV-11901.
const INTEGRATION_BOOKKEEPING_COLUMN_LABELS = new Set([
	'row_key',
	'row_hash',
	'row key',
	'row hash',
]);

export const isIntegrationBookkeepingColumn = (label) => {
	if (typeof label !== 'string') {
		return false;
	}

	return INTEGRATION_BOOKKEEPING_COLUMN_LABELS.has(label.trim().toLowerCase());
};
